<template>
  <div class="filter-btn-container">
    <div class="btn-primary bbt" @click="$emit('click')">
      <i :class="icon"></i
      ><span
        :style="`${title && icon ? 'margin-right: 5px !important' : ''}`"
        >{{ title }}</span
      >
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
    },
    icon: {
      type: String,
    },
  },
};
</script>
<style scoped>
.filter-btn-container {
  width: 100% !important;
  all: unset;
  list-style: none;
  display: inline-block;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  gap: 10px;
}
.bbt {
  float: right;
  padding: 6px 16px;
  background: #ccc;
  display: flex;
  align-items: center;
  justify-content: center;
  width: max-content;
}
.bbt:active {
  background-color: #0f8970 !important;
}
</style>
